import { render } from "./AlbumEditForm.vue?vue&type=template&id=d3c0f58c&scoped=true"
import script from "./AlbumEditForm.vue?vue&type=script&lang=js"
export * from "./AlbumEditForm.vue?vue&type=script&lang=js"

import "./AlbumEditForm.vue?vue&type=style&index=0&id=d3c0f58c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c0f58c"]])

export default __exports__